export const addGalleryPassword = (url: string, password: string) => {
  if (!password) return url;
  password = encodeURIComponent(password);
  if (url.includes('?')) {
    return `${url}&password=${password}`;
  }
  return `${url}?password=${password}`;
};
